import { render } from "./WithdrawDialog.vue?vue&type=template&id=20e3a130"
import script from "./WithdrawDialog.vue?vue&type=script&lang=js"
export * from "./WithdrawDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__